// Configuration Firebase pour l'application Polyar'Trottons.
// Les valeurs sont lues depuis les variables d'environnement (voir .env.example).
// Ne jamais committer le fichier .env réel dans Git.
//
// Note : Firebase Storage n'est pas utilisé (nécessite désormais le forfait
// payant Blaze). Les photos sont déposées sur Google Drive via un script
// Apps Script, voir src/utils/uploadPhotoToDrive.js et apps-script/PhotoUpload.gs.

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
